import { useInfiniteQuery } from '@tanstack/react-query';

import { activeOffersInfiniteQueryOptions } from '@/modules/offers/queries';
import { useCurrentUser } from '@/modules/user/useCurrentUser';

type Props = {
  enabled?: boolean;
};

export function useBuyersActiveOffers({ enabled = true }: Props = {}) {
  const [authenticated] = useCurrentUser();

  return useInfiniteQuery({
    ...activeOffersInfiniteQueryOptions(),
    enabled: authenticated && enabled,
  });
}
